import { FC, useEffect, useState } from 'react';
import { Modal, Loader, Center } from '@mantine/core';
import { Invoice, Patient, ServiceRequest } from '@medplum/fhirtypes';
import { useMedplum } from '@medplum/react';
import { PaymentSection } from '../components/PaymentSection';
import { getLinkedOrderRef } from '../utils/payment-helpers';

interface InvoiceDetailModalProps {
  opened: boolean;
  onClose: () => void;
  invoice: Invoice | null;
  patient?: Patient | null;
}

export const InvoiceDetailModal: FC<InvoiceDetailModalProps> = ({
  opened,
  onClose,
  invoice,
  patient,
}) => {
  const medplum = useMedplum();
  const [serviceRequest, setServiceRequest] = useState<ServiceRequest | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    if (opened && invoice) {
      const orderRef = getLinkedOrderRef(invoice);
      if (orderRef) {
        setLoading(true);
        medplum
          .readReference({ reference: orderRef } as any)
          .then((sr) => {
            if (active) {
              setServiceRequest(sr as ServiceRequest);
            }
          })
          .catch(console.error)
          .finally(() => {
            if (active) {
              setLoading(false);
            }
          });
      } else {
        setServiceRequest(null);
      }
    } else {
      setServiceRequest(null);
    }
    return () => {
      active = false;
    };
  }, [opened, invoice, medplum]);

  if (!invoice) return null;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      // title={t('payment.title', 'Payment Details', { ns: 'lims' })}
      size="xl"
      centered
    >
      {loading ? (
        <Center p="xl">
          <Loader />
        </Center>
      ) : (
        <PaymentSection
          serviceRequest={serviceRequest || undefined}
          patient={patient || undefined}
        />
      )}
    </Modal>
  );
};
